import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useFetchCustomer } from '../../hooks/customer-hooks';
import { useFetchOpportunity, useFetchOpportunityDeal } from '../../hooks/opportunity-hooks';
import { HbrDivider } from '@harbor/elements-react-standalone';

const OppDataCard: React.FC = () => {
  const { id: opportunityId } = useParams();
  const { data: opportunity } = useFetchOpportunity(opportunityId);
  const { data: customer } = useFetchCustomer(opportunity?.AccountId);
  const { data: deals } = useFetchOpportunityDeal(opportunityId);
  const [ dealId, setDealId ] = useState<string>();

  useEffect(() => {
    if (deals?.items?.length === 1 && deals.items[0].Id === opportunityId) {
      // deal id not always present
      setDealId(deals.items[0].DealID__c ?? '');
    }
  }, [deals, opportunityId]);

  if (!opportunity) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <dl className='hbr-css__layout-pairs-row'>
        <dt className='hbr-css__text-primary-sm-semibold'>Customer</dt>
        <dd className='hbr-css__text-primary-sm'>{customer?.Name}</dd>
        <dt className='hbr-css__text-primary-sm-semibold'>Deal ID</dt>
        <dd className='hbr-css__text-primary-sm'>{dealId}</dd>
        <dt className='hbr-css__text-primary-sm-semibold'>Forecast Category</dt>
        <dd className='hbr-css__text-primary-sm'>
          {opportunity.ForecastCategoryName}
        </dd>
        <dt className='hbr-css__text-primary-sm-semibold'>Forecast Status</dt>
        <dd className='hbr-css__text-primary-sm'>{opportunity.StageName}</dd>
        <dt className='hbr-css__text-primary-sm-semibold'>Value</dt>
        <dd className='hbr-css__text-primary-sm'>{opportunity.Amount}</dd>
        <dt className='hbr-css__text-primary-sm-semibold'>Last Updated</dt>
        <dd className='hbr-css__text-primary-sm'>
          {opportunity.LastModifiedDate}
        </dd>
      </dl>

      <HbrDivider className="mt-4" />
    </>
  );
};

export default OppDataCard;
